import Marionette from "backbone.marionette";

import PermissionsTable from "views/permissions/permissionsList.ejs";

import S from "session/session.js";
import T from "session/token.js";

export default Marionette.View.extend({
    template: PermissionsTable,
    render: function(data) {

        this.$el.html(this.template({
            permissions: this.collection.models[0].attributes.permissions,
            lang: this.collection.lang,
            roluser: this.collection.models[0].attributes.ROL_us
        }));
    },
    events: {
        "change .epigraph input": "epigraph",
        //"change .subepigraph input": "subepigraph"
    },
    epigraph: function(ev) {

        var className = $(ev.target).attr("class");
        $(".subepigraph[data-parent=" + $(ev.target).parents(".epigraph").attr("id") + "] ." + className).prop('checked', $(ev.target).prop('checked'));
    },
    /*
        subepigraph: function (ev) {
            var className = $(ev.target).attr("class");
            switch (className) {
                case "view":
                    $(ev.target).parents("tr").find(".edit").prop('checked', $(ev.target).prop('checked'));
                    $(ev.target).parents("tr").find(".delete").prop('checked', $(ev.target).prop('checked'));
                    break;
                case "edit":
                    $(ev.target).parents("tr").find(".delete").prop('checked', $(ev.target).prop('checked'));
                    break;
            }
        }*/
});


//////////////////
// WEBPACK FOOTER
// ./app/views/permissions/permissionsList.js
// module id = 202
// module chunks = 0